"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4682,107],{

/***/ 74682:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ SellOffers_Offer; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/layout/dist/index.esm.js
var index_esm = __webpack_require__(48641);
// EXTERNAL MODULE: ./src/uikit/Badges/LimitedOffer.tsx + 1 modules
var LimitedOffer = __webpack_require__(94999);
// EXTERNAL MODULE: ./src/uikit/Badges/Info.tsx
var Info = __webpack_require__(75600);
// EXTERNAL MODULE: ./src/uikit/Titles/OfferCard.tsx
var OfferCard = __webpack_require__(66018);
// EXTERNAL MODULE: ./src/uikit/Boxes/Price.tsx
var Price = __webpack_require__(64673);
// EXTERNAL MODULE: ./node_modules/react-i18next/dist/es/useTranslation.js + 6 modules
var useTranslation = __webpack_require__(18132);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 1 modules
var styled_components_browser_esm = __webpack_require__(53918);
// EXTERNAL MODULE: ./node_modules/ssr-window/ssr-window.esm.js
var ssr_window_esm = __webpack_require__(55352);
// EXTERNAL MODULE: ./src/utils/gtm/events.ts + 1 modules
var events = __webpack_require__(99778);
// EXTERNAL MODULE: ./src/utils/gtm/mappers.ts + 2 modules
var mappers = __webpack_require__(29590);
// EXTERNAL MODULE: ./src/utils/gtm/constants.ts
var constants = __webpack_require__(98845);
// EXTERNAL MODULE: ./src/utils/imageAlt.ts
var utils_imageAlt = __webpack_require__(61254);
// EXTERNAL MODULE: ./src/utils/sellFieldsVisibility.ts
var sellFieldsVisibility = __webpack_require__(25836);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/components/SellOffers/OfferDetails.tsx





const TextItem = _ref => {
  let {
    name,
    value
  } = _ref;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(index_esm/* Box */.xu, {
    display: "block",
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(index_esm/* Text */.xv, {
      color: "baseDark",
      fontFamily: "Montserrat-SemiBold",
      fontSize: "0.875rem",
      letterSpacing: "0.2px",
      lineHeight: "18px",
      display: "inline",
      children: name
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(index_esm/* Text */.xv, {
      color: "baseNeutral.700",
      fontFamily: "Montserrat-Medium",
      fontSize: "1rem",
      letterSpacing: "0.2px",
      lineHeight: "20.8px",
      display: "inline",
      children: [": ", value]
    })]
  });
};

const OfferDetails = _ref2 => {
  let {
    items,
    description
  } = _ref2;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(index_esm/* Stack */.Kq, {
    textAlign: "left",
    position: "absolute",
    bottom: "0",
    left: "0",
    right: "0",
    display: "block",
    bg: "baseWhite",
    p: "l",
    overflow: "hidden",
    children: [items.map(item => /*#__PURE__*/(0,jsx_runtime.jsx)(TextItem, {
      name: item.name,
      value: item.value
    }, item.name)), description && /*#__PURE__*/(0,jsx_runtime.jsx)(index_esm/* Text */.xv, {
      color: "baseNeutral.700",
      fontFamily: "Montserrat-Medium",
      fontSize: "0.75rem",
      letterSpacing: "0.4px",
      marginTop: "m",
      children: description
    })]
  });
};

/* harmony default export */ var SellOffers_OfferDetails = (OfferDetails);
;// CONCATENATED MODULE: ./src/components/SellOffers/Offer.tsx















const PriceDiscount = _ref => {
  let {
    name,
    value
  } = _ref;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(index_esm/* Box */.xu, {
    mt: "1.3rem",
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(index_esm/* Text */.xv, {
      color: "baseNeutral.700",
      fontFamily: "Montserrat-Medium",
      fontSize: "0.75rem",
      letterSpacing: "0.4px",
      display: "inline",
      children: `${name} `
    }), value && /*#__PURE__*/(0,jsx_runtime.jsx)(index_esm/* Text */.xv, {
      color: "baseNeutral.700",
      fontFamily: "Montserrat-Medium",
      fontSize: "1rem",
      letterSpacing: "0.2px",
      display: "inline",
      textDecoration: "line-through",
      children: value
    })]
  });
};

const BoxOverlayOpcaity = /*#__PURE__*/(0,styled_components_browser_esm["default"])(index_esm/* Box */.xu).withConfig({
  componentId: "sc-hhj6ta-0"
})(["height:12.5rem;margin-bottom:0.5rem;position:relative;background-color:", ";&:after{content:' ';z-index:0;display:block;position:absolute;height:100%;top:0;left:0;right:0;background:rgba(70,75,82,", ");}"], props => props.$active ? 'baseNeutral.800' : 'transparent', props => props.$active ? '0.5' : '0');

const Offer = _ref2 => {
  let {
    item,
    index,
    listId = 'sell_listing',
    listName = 'Auto in vendita'
  } = _ref2;
  const {
    t
  } = (0,useTranslation/* useTranslation */.$)();
  const {
    0: active,
    1: onClick
  } = (0,react.useState)(false);
  const router = (0,next_router.useRouter)();
  const detailHref = `/offerte-auto/${item.brandCode}/${item.modelCode}/${item.code}`;

  const showDetailsHandler = e => {
    e.stopPropagation();
    e.nativeEvent.stopImmediatePropagation();
    onClick(!active);
  };

  const getUrlWithReference = path => {
    const currentDocumentUrl = new URLSearchParams((0,ssr_window_esm/* getDocument */.Me)().location.search);
    const ref = currentDocumentUrl.get('ref');

    if (ref) {
      return `${path}?ref=${encodeURIComponent(ref)}`;
    }

    return path;
  };

  const gotoDetailsHandler = () => {
    (0,events/* pushSelectItem */.Yy)({
      item: (0,mappers/* sellOfferToProductItem */.rW)(item, {
        index
      }),
      listId,
      listName,
      click: {
        link_text: `${item.brand} ${item.model}`,
        link_url: detailHref,
        link_type: constants/* CTA_PRODUCT_PAGE */.Ot
      }
    });
    router.push(getUrlWithReference(detailHref));
  };

  const title = `${item.brand} ${item.model}`;
  const imageAlt = (0,utils_imageAlt/* getOfferCardAlt */.Pr)(item, 'in vendita', item.imageAlt);
  const priceValue = t('nltOffersComponent:priceValue', {
    value: parseInt(`${item.price}`).toLocaleString('it-IT')
  });
  const specialPriceValue = (0,sellFieldsVisibility/* isSellFieldVisible */.M)(item.fieldsVisibility, 'SPECIALPRICE') && item.specialPrice && item.specialPrice > 0 ? t('nltOffersComponent:priceValue', {
    value: parseInt(`${item.specialPrice}`).toLocaleString('it-IT')
  }) : null;
  const monthlyRateValue = (0,sellFieldsVisibility/* isSellFieldVisible */.M)(item.fieldsVisibility, 'MONTHLYRATE') && item.monthlyRate && item.monthlyRate > 0 ? t('sellOffersComponent:monthlyRateValue', {
    value: parseInt(`${item.monthlyRate}`).toLocaleString('it-IT')
  }) : null;
  const offerDetailsItems = [];

  if (monthlyRateValue) {
    offerDetailsItems.push({
      name: t('sellOffersComponent:monthlyRateTitle'),
      value: monthlyRateValue
    });
  }

  if ((0,sellFieldsVisibility/* isSellFieldVisible */.M)(item.fieldsVisibility, 'DEPOSIT')) {
    offerDetailsItems.push({
      name: t('sellOffersComponent:depositTitle'),
      value: t('sellOffersComponent:depositValue', {
        value: item.deposit.toLocaleString('it-IT')
      })
    });
  }

  if (item.tan > 0) {
    offerDetailsItems.push({
      name: t('sellOffersComponent:tanTitle'),
      value: t('sellOffersComponent:tanValue', {
        value: item.tan ? item.tan.toLocaleString('it-IT') : 0
      })
    });
  }

  if (item.taeg > 0) {
    offerDetailsItems.push({
      name: t('sellOffersComponent:taegTitle'),
      value: t('sellOffersComponent:taegValue', {
        value: item.taeg ? item.taeg.toLocaleString('it-IT') : 0
      })
    });
  }

  let limitedOfferBadge = null;

  if (item.expiresAt) {
    const offerTimeStamp = Date.parse(item.expiresAt);
    const nowTimeStamp = new Date().getTime();
    const diffTimeStamp = offerTimeStamp - nowTimeStamp;

    if (diffTimeStamp > 0) {
      limitedOfferBadge = t('nltOffersComponent:limitedOfferBadge', {
        value: Math.floor(diffTimeStamp / (24 * 60 * 60 * 1000))
      });
    }
  }

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(index_esm/* Box */.xu, {
    w: "full",
    title: title,
    borderRadius: 10,
    bg: "baseWhite",
    overflow: "hidden",
    borderColor: active ? 'primaryGreen.600' : '#d9dde1',
    borderWidth: "1px",
    boxShadow: "0 2px 8px 0px rgba(65, 164, 118, 0.12)",
    _hover: {
      cursor: 'pointer',
      textDecoration: 'none',
      boxShadow: '0 4px 12px 0px rgba(65, 164, 118, 0.22)'
    },
    onClick: gotoDetailsHandler,
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(BoxOverlayOpcaity, {
      $active: active,
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
        src: item.image,
        alt: imageAlt,
        layout: "fill",
        objectFit: "contain",
        loading: "lazy"
      }), limitedOfferBadge && /*#__PURE__*/(0,jsx_runtime.jsx)(LimitedOffer/* default */.Z, {
        position: "absolute",
        top: "1rem",
        left: "1rem",
        children: limitedOfferBadge
      }), item.mainTag && /*#__PURE__*/(0,jsx_runtime.jsx)(Info/* default */.Z, {
        position: "absolute",
        bottom: ".625rem",
        left: "1rem",
        children: item.mainTag
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(index_esm/* Divider */.iz, {
        color: "red",
        position: "absolute",
        bottom: "0rem"
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(index_esm/* Stack */.Kq, {
      textAlign: "left",
      pos: "relative",
      height: "7rem",
      children: [!active && /*#__PURE__*/(0,jsx_runtime.jsxs)(index_esm/* Box */.xu, {
        px: "l",
        color: "baseDark",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("a", {
          href: getUrlWithReference(detailHref),
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(OfferCard/* default */.Z, {
            title: title,
            subtitle: item.version
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)(index_esm/* Box */.xu, {
          children: [monthlyRateValue ? /*#__PURE__*/(0,jsx_runtime.jsx)(Price/* default */.Z, {
            value: monthlyRateValue,
            description: t('sellOffersComponent:priceDescriptionMonthly'),
            textAlign: "right",
            position: "absolute",
            top: "3.8rem",
            right: "1.5rem"
          }) : /*#__PURE__*/(0,jsx_runtime.jsx)(Price/* default */.Z, {
            value: specialPriceValue || priceValue,
            description: t('sellOffersComponent:priceDescription'),
            textAlign: "right",
            position: "absolute",
            top: "3.8rem",
            right: "1.5rem"
          }), specialPriceValue && /*#__PURE__*/(0,jsx_runtime.jsx)(PriceDiscount, {
            name: t('sellOffersComponent:priceStartFrom'),
            value: specialPriceValue ? priceValue : null
          })]
        })]
      }), active && /*#__PURE__*/(0,jsx_runtime.jsx)(SellOffers_OfferDetails, {
        items: offerDetailsItems,
        description: item.description
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(index_esm/* Text */.xv, {
      color: "baseDark",
      fontFamily: "Montserrat-Medium",
      fontSize: "1rem",
      pb: "l",
      letterSpacing: "0.4px",
      onClick: showDetailsHandler,
      cursor: "pointer",
      title: active ? t('sellOffersComponent:hideDetails') : t('sellOffersComponent:showDetails'),
      children: active ? `${t('sellOffersComponent:hideDetails')} - ` : `${t('sellOffersComponent:showDetails')} +`
    })]
  });
};

/* harmony default export */ var SellOffers_Offer = (Offer);

/***/ }),

/***/ 75600:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _codebuild_output_src1686024941_src_mr_planner_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);
/* harmony import */ var _codebuild_output_src1686024941_src_mr_planner_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(4730);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(48641);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85893);


const _excluded = ["children"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_codebuild_output_src1686024941_src_mr_planner_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }





const Info = _ref => {
  let {
    children
  } = _ref,
      others = (0,_codebuild_output_src1686024941_src_mr_planner_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_ref, _excluded);

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_4__/* .Badge */ .Ct, _objectSpread(_objectSpread({
    bg: "baseNeutral.700",
    fontFamily: "Montserrat-SemiBold",
    fontSize: "0.625rem",
    color: "baseWhite",
    lineHeight: "15px",
    letterSpacing: ".33px",
    rounded: "15px",
    paddingY: ".3rem",
    paddingX: ".5rem"
  }, others), {}, {
    children: children
  }));
};

/* harmony default export */ __webpack_exports__["Z"] = (Info);

/***/ }),

/***/ 94999:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Badges_LimitedOffer; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js + 1 modules
var objectWithoutProperties = __webpack_require__(4730);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/layout/dist/index.esm.js
var index_esm = __webpack_require__(48641);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 1 modules
var styled_components_browser_esm = __webpack_require__(53918);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/icons/clock.tsx


const ClockIcon = () => /*#__PURE__*/(0,jsx_runtime.jsx)("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "14",
  height: "14",
  viewBox: "0 0 14 14",
  children: /*#__PURE__*/(0,jsx_runtime.jsx)("g", {
    fill: "none",
    fillRule: "evenodd",
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("g", {
      fill: "#262626",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
        d: "M12.272 12.673c.228-.214.228-.56 0-.773l-1.033-.968c.753-.875 1.203-1.99 1.203-3.201.002-.761-.175-1.483-.491-2.13.542-.468.882-1.137.882-1.883 0-1.41-1.217-2.551-2.722-2.551-1.1 0-2.049.61-2.477 1.492-.42-.046-.848-.046-1.268 0-.428-.882-1.376-1.492-2.477-1.492-1.505 0-2.722 1.141-2.722 2.551 0 .746.34 1.415.882 1.882-.316.648-.493 1.37-.493 2.129 0 1.212.452 2.326 1.203 3.2l-1.033.969c-.229.214-.229.56 0 .772.228.215.598.215.824 0l1.033-.968c1.98 1.497 4.83 1.513 6.83 0l1.035.97c.228.215.598.215.824 0zm-.946-8.045c-.636-.78-1.507-1.381-2.51-1.714.277-.394.753-.654 1.295-.654.858 0 1.556.654 1.556 1.458 0 .345-.13.661-.34.91zm-8.65 0c-.214-.249-.343-.565-.343-.91 0-.804.698-1.458 1.556-1.458.542 0 1.018.26 1.298.654-1.006.333-1.877.934-2.511 1.714zM7 11.738c-2.365 0-4.278-1.793-4.278-4.01 0-2.21 1.906-4.01 4.278-4.01 2.367 0 4.278 1.796 4.278 4.01 0 2.217-1.913 4.01-4.278 4.01zm1.531-2.25l.44-.602c.09-.125.059-.294-.075-.38L7.68 7.721V5.268c0-.15-.132-.274-.292-.274H6.61c-.16 0-.292.123-.292.274V8.25c0 .091.047.176.127.226l1.677 1.082c.134.084.316.052.408-.07z",
        transform: "translate(-413 -1472) translate(45 1377) translate(344 75) translate(16 16) translate(8 4)"
      })
    })
  })
});

/* harmony default export */ var clock = (ClockIcon);
;// CONCATENATED MODULE: ./src/uikit/Badges/LimitedOffer.tsx


const _excluded = ["children"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }







const LimitedOfferStyle = /*#__PURE__*/(0,styled_components_browser_esm["default"])(index_esm/* Box */.xu).withConfig({
  componentId: "sc-1kch8fu-0"
})(["& svg{display:inline;margin-right:4px;vertical-align:sub;}"]);

const LimitedOffer = _ref => {
  let {
    children
  } = _ref,
      others = (0,objectWithoutProperties/* default */.Z)(_ref, _excluded);

  return /*#__PURE__*/(0,jsx_runtime.jsx)(LimitedOfferStyle, _objectSpread(_objectSpread({}, others), {}, {
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)(index_esm/* Badge */.Ct, {
      bg: "feedbackWarning",
      color: "baseDark",
      fontFamily: "Montserrat-SemiBold",
      fontSize: "0.625rem",
      lineHeight: "15.6px",
      letterSpacing: ".33px",
      rounded: "15px",
      paddingY: ".3rem",
      paddingX: ".5rem",
      textTransform: "initial",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(clock, {}), children]
    })
  }));
};

/* harmony default export */ var Badges_LimitedOffer = (LimitedOffer);

/***/ }),

/***/ 64673:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _codebuild_output_src1686024941_src_mr_planner_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);
/* harmony import */ var _codebuild_output_src1686024941_src_mr_planner_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(4730);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(53918);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(48641);
/* harmony import */ var src_styles_styled_components_Texts__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(2732);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85893);


const _excluded = ["value", "description"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_codebuild_output_src1686024941_src_mr_planner_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }







const BoxDescription = /*#__PURE__*/styled_components__WEBPACK_IMPORTED_MODULE_3__["default"].span.withConfig({
  componentId: "sc-zru8zp-0"
})(["display:block;margin-top:0;", ""], src_styles_styled_components_Texts__WEBPACK_IMPORTED_MODULE_4__/* .TextStyles.infoXxsN700MediumDx */ .k.infoXxsN700MediumDx);

const PriceBox = _ref => {
  let {
    value,
    description
  } = _ref,
      others = (0,_codebuild_output_src1686024941_src_mr_planner_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_ref, _excluded);

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_6__/* .Box */ .xu, _objectSpread(_objectSpread({
    color: "baseDark",
    fontFamily: "Montserrat-SemiBold",
    fontSize: "1.5rem",
    lineHeight: "31.2px",
    letterSpacing: "0.86px"
  }, others), {}, {
    children: [value, description && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(BoxDescription, {
      children: description
    })]
  }));
};

/* harmony default export */ __webpack_exports__["Z"] = (PriceBox);

/***/ }),

/***/ 66018:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(48641);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);






const OfferCard = _ref => {
  let {
    title,
    subtitle,
    href
  } = _ref;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Text */ .xv, {
      color: "baseDark",
      fontFamily: "Montserrat-SemiBold",
      fontSize: "1rem",
      lineHeight: "21px",
      letterSpacing: "0.2px",
      children: href ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("a", {
        href: href,
        children: title
      }) : title
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Text */ .xv, {
      color: "baseNeutral.700",
      fontFamily: "Montserrat-Regular",
      fontSize: "0.875rem",
      textTransform: "capitalize",
      lineHeight: "18px",
      letterSpacing: "0.2px",
      marginTop: "0rem!important",
      mb: "xs",
      whiteSpace: "nowrap",
      overflow: "hidden",
      textOverflow: "ellipsis",
      children: href ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("a", {
        href: href,
        children: subtitle
      }) : subtitle
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Divider */ .iz, {})]
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (OfferCard);

/***/ }),

/***/ 73119:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "P": function() { return /* binding */ getFormattedMonthYear; },
/* harmony export */   "h": function() { return /* binding */ replaceDatePlaceholders; }
/* harmony export */ });
const currentDate = new Date();
const monthYear = currentDate.toLocaleString('it-IT', {
  month: 'long',
  year: 'numeric'
});
const formattedMonth = monthYear.charAt(0).toUpperCase() + monthYear.slice(1, -5);
const formattedYear = currentDate.getFullYear();
const getFormattedMonthYear = () => {
  return {
    formattedMonth,
    formattedYear
  };
};
const replaceDatePlaceholders = text => {
  if (!text) return null; // Fallback se il testo è null o undefined

  return text.replace('{{month}}', formattedMonth).replace('{{year}}', String(formattedYear));
};

/***/ }),

/***/ 29590:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "tH": function() { return /* binding */ rentOfferToPageMeta; },
  "ck": function() { return /* binding */ rentOfferToProductItem; },
  "np": function() { return /* binding */ sellOfferToPageMeta; },
  "rW": function() { return /* binding */ sellOfferToProductItem; }
});

// UNUSED EXPORTS: rentOfferToOfferData, rentOfferValue, sellOfferToOfferData, sellOfferValue, toNumber

// EXTERNAL MODULE: ./src/utils/gtm/constants.ts
var constants = __webpack_require__(98845);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./src/utils/gtm/naming.ts
var naming = __webpack_require__(31067);
;// CONCATENATED MODULE: ./src/utils/gtm/brandRules.json
var brandRules_namespaceObject = JSON.parse('{"fiat":{"rpl":22,"offerCustomerType":"B2C","offerType":"Finanziamento"},"jeep":{"rpl":27.5,"offerCustomerType":"B2C","offerType":"Finanziamento"},"bmw":{"offerCustomerType":"B2C","offerType":"Leasing"},"toyota":{"offerCustomerType":"B2B","offerType":"Finanziamento"},"peugeot":{"offerCustomerType":"B2C","offerType":"Finanziamento"}}');
;// CONCATENATED MODULE: ./src/utils/gtm/brandRules.ts


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

/**
 * Valori commerciali che variano per brand automotive.
 *
 * Oggi vivono in un JSON versionato ([brandRules.json](./brandRules.json)): sono
 * accordi commerciali che cambiano di rado e che il backend non espone. La
 * lettura passa da `getBrandRules`, così che il giorno in cui l'offers-explorer
 * restituirà questi campi basti cambiare questa implementazione senza toccare
 * i punti di chiamata.
 *
 * Un brand non mappato NON eredita un rpl inventato: la chiave viene omessa.
 */



const DEFAULT_RULES = {
  offerCustomerType: 'B2C',
  offerType: constants/* DEFAULT_OFFER_TYPE */.OJ
};
function getBrandRules(brandCode) {
  const key = (0,naming/* slugSegment */.nL)(brandCode);
  const brandRules = key ? brandRules_namespaceObject[key] : undefined;
  return _objectSpread(_objectSpread({}, DEFAULT_RULES), brandRules);
}
;// CONCATENATED MODULE: ./src/utils/gtm/mappers.ts
/**
 * Dai DTO dell'offers-explorer agli oggetti dello schema dataLayer.
 *
 * Attenzione alla semantica dei prezzi, invertita rispetto a quella intuitiva:
 * `ecommerce.items[].price` è il prezzo di LISTINO, mentre `ecommerce.value` è
 * il prezzo promozionale/corrente. GA4 non sottrae mai `discount` da `price`.
 */



/** Converte in numero positivo; qualunque altro caso diventa `undefined` (chiave omessa). */
function toNumber(value) {
  if (value === null || value === undefined || value === '') return undefined;
  const parsed = typeof value === 'number' ? value : parseFloat(`${value}`);
  return Number.isFinite(parsed) && parsed > 0 ? parsed : undefined;
}

const absoluteUrl = path => path ? `${constants/* SITE_ORIGIN */.yp}${path.split('?')[0].split('#')[0]}` : undefined;

const withQuery = path => path ? `${constants/* SITE_ORIGIN */.yp}${path}` : undefined;

const sellOfferPath = offer => {
  var _offer$vehicle, _offer$vehicle2;

  return `/offerte-auto/${((_offer$vehicle = offer.vehicle) === null || _offer$vehicle === void 0 ? void 0 : _offer$vehicle.brandCode) ?? offer.brandCode}/${((_offer$vehicle2 = offer.vehicle) === null || _offer$vehicle2 === void 0 ? void 0 : _offer$vehicle2.modelCode) ?? offer.modelCode}/${offer.code}`;
};

const rentOfferPath = offer => {
  var _offer$vehicle3, _offer$vehicle4;

  return `/noleggio-a-lungo-termine/${((_offer$vehicle3 = offer.vehicle) === null || _offer$vehicle3 === void 0 ? void 0 : _offer$vehicle3.brandCode) ?? offer.brandCode}/${((_offer$vehicle4 = offer.vehicle) === null || _offer$vehicle4 === void 0 ? void 0 : _offer$vehicle4.modelCode) ?? offer.modelCode}/${offer.code}`;
};

function sellOfferToProductItem(offer) {
  var _vehicle$engine;

  let {
    path,
    index
  } = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  const detail = offer;
  const {
    vehicle
  } = detail;
  const brand = (vehicle === null || vehicle === void 0 ? void 0 : vehicle.brand) ?? offer.brand;
  const model = (vehicle === null || vehicle === void 0 ? void 0 : vehicle.model) ?? offer.model;
  const version = (vehicle === null || vehicle === void 0 ? void 0 : vehicle.version) ?? offer.version;
  const fuel = vehicle === null || vehicle === void 0 ? void 0 : (_vehicle$engine = vehicle.engine) === null || _vehicle$engine === void 0 ? void 0 : _vehicle$engine.fuel;
  const canonicalPath = path || sellOfferPath(offer);
  return {
    item_id: offer.code,
    item_name: [brand, model, fuel].filter(Boolean).join(' ') || undefined,
    item_brand: brand,
    item_variant: model,
    item_category: fuel,
    item_category2: constants/* VEHICLE_CONDITION */.zN,
    item_category3: vehicle === null || vehicle === void 0 ? void 0 : vehicle.category,
    item_category4: detail.year ? `${detail.year}` : undefined,
    item_category5: version,
    price: toNumber(offer.price),
    currency: constants/* CURRENCY */.wA,
    discount: toNumber(detail.priceReduction),
    image_url: detail.image,
    item_url: withQuery(canonicalPath),
    product_url: absoluteUrl(canonicalPath),
    product_type: constants/* PRODUCT_TYPE */.fY,
    index
  };
}
function rentOfferToProductItem(offer) {
  var _vehicle$engine2, _detail$images, _detail$images$;

  let {
    path,
    index
  } = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  const detail = offer;
  const item = offer;
  const {
    vehicle
  } = detail;
  const brand = (vehicle === null || vehicle === void 0 ? void 0 : vehicle.brand) ?? item.brand;
  const model = (vehicle === null || vehicle === void 0 ? void 0 : vehicle.model) ?? item.model;
  const version = (vehicle === null || vehicle === void 0 ? void 0 : vehicle.version) ?? item.version;
  const fuel = vehicle === null || vehicle === void 0 ? void 0 : (_vehicle$engine2 = vehicle.engine) === null || _vehicle$engine2 === void 0 ? void 0 : _vehicle$engine2.fuel;
  const canonicalPath = path || rentOfferPath(offer);
  return {
    item_id: offer.code,
    item_name: [brand, model, fuel].filter(Boolean).join(' ') || undefined,
    item_brand: brand,
    item_variant: model,
    item_category: fuel,
    item_category2: constants/* VEHICLE_CONDITION */.zN,
    item_category3: (vehicle === null || vehicle === void 0 ? void 0 : vehicle.category) ?? item.category,
    item_category5: version,
    // Il noleggio non espone un prezzo di listino del veicolo: resta omesso.
    price: toNumber(detail.specialPrice),
    currency: constants/* CURRENCY */.wA,
    image_url: ((_detail$images = detail.images) === null || _detail$images === void 0 ? void 0 : (_detail$images$ = _detail$images[0]) === null || _detail$images$ === void 0 ? void 0 : _detail$images$.src) ?? item.image,
    item_url: withQuery(canonicalPath),
    product_url: absoluteUrl(canonicalPath),
    product_type: constants/* PRODUCT_TYPE */.fY,
    index
  };
}
function sellOfferToOfferData(offer) {
  var _offer$vehicle5;

  const brandCode = ((_offer$vehicle5 = offer.vehicle) === null || _offer$vehicle5 === void 0 ? void 0 : _offer$vehicle5.brandCode) ?? offer.brandCode;
  const rules = getBrandRules(brandCode);
  return {
    offer_type: rules.offerType,
    offer_customer_type: rules.offerCustomerType,
    offer_acquisition_type: constants/* OFFER_ACQUISITION_TYPE */.Vd,
    monthly_payment: toNumber(offer.monthlyRate)
  };
}
function rentOfferToOfferData(offer) {
  return {
    offer_type: constants/* RENT_OFFER_TYPE */.y,
    offer_customer_type: offer.customerType === 'piva' ? 'B2B' : 'B2C',
    offer_acquisition_type: constants/* OFFER_ACQUISITION_TYPE */.Vd,
    monthly_payment: toNumber(offer.monthlyRate)
  };
}
/** Prezzo promozionale/corrente del veicolo. */

const sellOfferValue = offer => toNumber(offer.specialPrice) ?? toNumber(offer.price);
/** Per il noleggio l'unico valore economico esposto è il canone mensile. */

const rentOfferValue = offer => toNumber(offer.monthlyRate);

/** Meta di pagina per la VDP sell, pronta per `useGtmPage`. */
function sellOfferToPageMeta(offer) {
  var _vehicle$engine3;

  let {
    path,
    pageTitle,
    pageType = 'vdp'
  } = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  const {
    vehicle
  } = offer;
  const brandCode = (vehicle === null || vehicle === void 0 ? void 0 : vehicle.brandCode) ?? offer.brandCode;
  return {
    pageType,
    cmsPageId: offer.code,
    pageTitle,
    brand: (vehicle === null || vehicle === void 0 ? void 0 : vehicle.brand) ?? offer.brand,
    model: (vehicle === null || vehicle === void 0 ? void 0 : vehicle.model) ?? offer.model,
    fuel: vehicle === null || vehicle === void 0 ? void 0 : (_vehicle$engine3 = vehicle.engine) === null || _vehicle$engine3 === void 0 ? void 0 : _vehicle$engine3.fuel,
    segment: (vehicle === null || vehicle === void 0 ? void 0 : vehicle.categorySlug) ?? (vehicle === null || vehicle === void 0 ? void 0 : vehicle.category),
    rpl: getBrandRules(brandCode).rpl,
    productItem: sellOfferToProductItem(offer, {
      path
    }),
    offerData: sellOfferToOfferData(offer),
    value: sellOfferValue(offer)
  };
}
/** Meta di pagina per la VDP noleggio, pronta per `useGtmPage`. */

function rentOfferToPageMeta(offer) {
  var _vehicle$engine4;

  let {
    path,
    pageTitle,
    pageType = 'vdp'
  } = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  const {
    vehicle
  } = offer;
  return {
    pageType,
    cmsPageId: offer.code,
    pageTitle,
    brand: vehicle === null || vehicle === void 0 ? void 0 : vehicle.brand,
    model: vehicle === null || vehicle === void 0 ? void 0 : vehicle.model,
    fuel: vehicle === null || vehicle === void 0 ? void 0 : (_vehicle$engine4 = vehicle.engine) === null || _vehicle$engine4 === void 0 ? void 0 : _vehicle$engine4.fuel,
    segment: (vehicle === null || vehicle === void 0 ? void 0 : vehicle.categorySlug) ?? (vehicle === null || vehicle === void 0 ? void 0 : vehicle.category),
    rpl: getBrandRules(vehicle === null || vehicle === void 0 ? void 0 : vehicle.brandCode).rpl,
    productItem: rentOfferToProductItem(offer, {
      path
    }),
    offerData: rentOfferToOfferData(offer),
    value: rentOfferValue(offer)
  };
}

/***/ }),

/***/ 61254:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "CY": function() { return /* binding */ getGalleryImagesAlt; },
/* harmony export */   "KX": function() { return /* binding */ getSellVehicleAltData; },
/* harmony export */   "NB": function() { return /* binding */ UNKNOWN_MAIN_VIEW; },
/* harmony export */   "Pr": function() { return /* binding */ getOfferCardAlt; },
/* harmony export */   "fU": function() { return /* binding */ getBrandLogoAlt; },
/* harmony export */   "k8": function() { return /* binding */ getVehicleImageAlt; }
/* harmony export */ });
/* unused harmony exports MAIN_IMAGE_VIEW, UNKNOWN_VIEW, getVehicleAltBase, getVehicleImageView */
/* harmony import */ var _codebuild_output_src1686024941_src_mr_planner_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);
/* harmony import */ var _dateUtils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(73119);


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_codebuild_output_src1686024941_src_mr_planner_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


/**
 * Attributo ALT delle immagini dei veicoli.
 *
 * Template richiesto per la foto principale di ogni offerta:
 *   {Brand} {Modello} {Versione} {Anno} – vista laterale sinistra
 *
 * Il template si applica quando lo scatto e' davvero una laterale sinistra.
 * Quando non lo e', l'alt dichiara l'angolazione reale ricavata dall'alt che
 * arriva da offers-explorer: descrivere un'inquadratura diversa da quella
 * mostrata vale meno di un alt generico, sia per chi usa uno screen reader sia
 * per la SEO. Sulle offerte di noleggio, ad esempio, la prima foto e' quasi
 * sempre un frontale e non una laterale sinistra.
 */

const MAIN_IMAGE_VIEW = 'vista laterale sinistra';
/** Prima foto con angolazione non ricavabile: e' comunque un esterno dell'auto. */

const UNKNOWN_MAIN_VIEW = 'vista esterna';
/** Foto successive alla prima con angolazione non ricavabile. */

const UNKNOWN_VIEW = 'altra vista';
const ALT_SEPARATOR = ' – ';

/**
 * Angolazioni riconosciute, dalla piu' specifica alla piu' generica:
 * l'ordine conta perche' "Anteriore Sinistra" deve vincere su "Anteriore".
 * Le stringhe che non descrivono un'inquadratura ("Vista Identificativa",
 * "Offerta auto {Modello}") non hanno una regola di proposito: devono cadere
 * sul fallback invece di far dichiarare un'angolazione inventata.
 */
const VIEW_RULES = [{
  pattern: /(anteriore|frontale|front)[\s-]*(sinistr\w*|sx)/i,
  view: 'vista tre quarti anteriore sinistra'
}, {
  pattern: /(anteriore|frontale|front)[\s-]*(destr\w*|dx)/i,
  view: 'vista tre quarti anteriore destra'
}, {
  pattern: /(posteriore|retro|rear)[\s-]*(sinistr\w*|sx)/i,
  view: 'vista tre quarti posteriore sinistra'
}, {
  pattern: /(posteriore|retro|rear)[\s-]*(destr\w*|dx)/i,
  view: 'vista tre quarti posteriore destra'
}, {
  pattern: /(laterale|fiancata|lato|side)[\s-]*(sinistr\w*|sx)/i,
  view: 'vista laterale sinistra'
}, {
  pattern: /(laterale|fiancata|lato|side)[\s-]*(destr\w*|dx)/i,
  view: 'vista laterale destra'
}, {
  pattern: /(obliqu\w*|tre quarti|3\/4)/i,
  view: 'vista tre quarti'
}, {
  pattern: /(interni|abitacolo|sedili)/i,
  view: 'vista interni'
}, {
  pattern: /(plancia|cruscotto|dashboard)/i,
  view: 'vista plancia e cruscotto'
}, {
  pattern: /(bagagliaio|baule|trunk)/i,
  view: 'vista bagagliaio'
}, {
  pattern: /(cerchi|cerchio|ruote|wheel)/i,
  view: 'dettaglio cerchi'
}, {
  pattern: /(anteriore|frontale|front)/i,
  view: 'vista frontale'
}, {
  pattern: /(posteriore|retro|rear)/i,
  view: 'vista posteriore'
}, {
  pattern: /(laterale|fiancata|side)/i,
  view: 'vista laterale'
}];

const squash = value => value.replace(/\s+/g, ' ').trim();
/**
 * "{Brand} {Modello} {Versione} {Anno}".
 * Le offerte di noleggio riguardano auto nuove e non espongono un anno di
 * immatricolazione, quindi si usa l'anno corrente, coerente con title e meta
 * description. Le offerte di vendita che valorizzano `year` usano il proprio.
 */


const getVehicleAltBase = function () {
  let {
    name,
    brand,
    model,
    version,
    year
  } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  const {
    formattedYear
  } = (0,_dateUtils__WEBPACK_IMPORTED_MODULE_1__/* .getFormattedMonthYear */ .P)();
  const vehicleName = name || `${brand || ''} ${model || ''}`;
  return squash([vehicleName, version, `${year || formattedYear}`].filter(Boolean).join(' '));
};
/**
 * Ricava l'angolazione dall'alt di origine, null se non e' riconoscibile.
 */

const getVehicleImageView = sourceAlt => {
  if (!sourceAlt) {
    return null;
  }

  const rule = VIEW_RULES.find(_ref => {
    let {
      pattern
    } = _ref;
    return pattern.test(sourceAlt);
  });
  return rule ? rule.view : null;
};
/**
 * Alt completo di una foto veicolo. `view` e' obbligatorio: va passata
 * l'angolazione reale dello scatto, non un default.
 */

const getVehicleImageAlt = (vehicle, view) => `${getVehicleAltBase(vehicle)}${ALT_SEPARATOR}${view}`;
/**
 * Alt per le card delle liste, dove l'angolazione spesso non e' nota: viene
 * aggiunta solo se ricavabile dall'alt di origine, altrimenti si resta sul
 * veicolo piu' il contesto (es. "noleggio a lungo termine").
 */

const getOfferCardAlt = (vehicle, context, sourceAlt) => {
  const base = squash(`${getVehicleAltBase(vehicle)} ${context}`);
  const view = getVehicleImageView(sourceAlt);
  return view ? `${base}${ALT_SEPARATOR}${view}` : base;
};
/**
 * Alt dei loghi di marca, unico punto in cui si compone la stringa "Logo ...".
 *
 * Va usata ovunque compaia un logo di marca - card marchi, titolo del PDP,
 * banner partnership, heading della privacy - cosi' la forma della stringa
 * resta una sola. Il `context` opzionale aggiunge la qualifica quando serve
 * distinguere il contesto (es. "Noleggio a Lungo Termine").
 */

const getBrandLogoAlt = (brand, context) => squash(`Logo ${brand || ''} ${context || ''}`);
/**
 * Dati anagrafici di un'offerta di vendita nella forma attesa dagli helper.
 * Il dettaglio espone brand/model/version sia sulla radice sia su `vehicle`,
 * che pero' e' opzionale e viene popolato solo se l'enrichment riesce.
 */

const getSellVehicleAltData = offer => {
  var _offer$vehicle, _offer$vehicle2, _offer$vehicle3, _offer$vehicle4;

  return {
    name: (_offer$vehicle = offer.vehicle) === null || _offer$vehicle === void 0 ? void 0 : _offer$vehicle.name,
    brand: ((_offer$vehicle2 = offer.vehicle) === null || _offer$vehicle2 === void 0 ? void 0 : _offer$vehicle2.brand) || offer.brand,
    model: ((_offer$vehicle3 = offer.vehicle) === null || _offer$vehicle3 === void 0 ? void 0 : _offer$vehicle3.model) || offer.model,
    version: ((_offer$vehicle4 = offer.vehicle) === null || _offer$vehicle4 === void 0 ? void 0 : _offer$vehicle4.version) || offer.version,
    year: offer.year
  };
};
/**
 * Riscrive gli alt di tutte le foto della gallery mantenendo l'angolazione
 * reale dello scatto. Eventuali collisioni vengono numerate per non avere due
 * alt identici nella stessa pagina.
 */

const getGalleryImagesAlt = (images, vehicle) => {
  if (!images || !images.length) {
    return [];
  }

  const usedAlts = [];
  return images.map((image, index) => {
    const view = getVehicleImageView(image.alt) || (index === 0 ? UNKNOWN_MAIN_VIEW : UNKNOWN_VIEW);
    const baseAlt = getVehicleImageAlt(vehicle, view);
    let alt = baseAlt;
    let occurrence = 1;

    while (usedAlts.indexOf(alt) !== -1) {
      occurrence += 1;
      alt = `${baseAlt} (${occurrence})`;
    }

    usedAlts.push(alt);
    return _objectSpread(_objectSpread({}, image), {}, {
      alt
    });
  });
};

/***/ }),

/***/ 25836:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "M": function() { return /* binding */ isSellFieldVisible; }
/* harmony export */ });
// offers-explorer manda un oggetto con i soli toggle accesi del backoffice,
// es. { IS_VISIBLE_ON_WEBSITE_PRICE: true }: chiave assente = toggle spento.
// Senza configurazione (null) si mostra tutto, come prima.
function isSellFieldVisible(fieldsVisibility, field) {
  if (!fieldsVisibility) return true;
  return Boolean(fieldsVisibility[`IS_VISIBLE_ON_WEBSITE_${field}`]);
}

/***/ }),

/***/ 4730:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ _objectWithoutProperties; }
});

;// CONCATENATED MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}
;// CONCATENATED MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

/***/ })

}]);